module.exports = __webpack_public_path__ + "static/media/fonts-4-mobile.6ee0ed12.svg";